import { AdminFeedbacksListRequest } from '@common/model/admin/catalog/feedback';
import { ProcessingCountersRequest, ProcessingListRequest } from '@common/model/processing';
import { DealStatus } from '@common/model/deal';
import { DEFAULT_FILTERS_VALUES, PER_PAGE } from '../lib/config';
import { ProcessingAndReviewsFiltersType, ProcessingAndReviewsQueryParams } from '../ui/processingAndReviews';

export const ProcessingAndReviewsMapper = {
  toProcessingQuery: (filters: ProcessingAndReviewsFiltersType): ProcessingListRequest => {
    const request: ProcessingListRequest = {
      page: filters.page,
      pagination: PER_PAGE,
      cityId: filters.cityId,
      type: filters.clientType,
      dealStatus: filters.dealStatus,
      careerId: filters.careerId,
      phoneOrEmail: filters.phoneOrEmail,
      rejectionReason: filters.rejectionReason,
      vacancyId: {
        isEmpty: true,
      },
      sorters: {
        createdAt: 'desc',
      },
    };
    if (filters.dealStatus === DealStatus.Completed) {
      request.feedbacksCount = { lt: 2 };
    }
    return request;
  },
  toFeedbacksQuery: (filters: ProcessingAndReviewsFiltersType, withOnlyCount?: boolean): AdminFeedbacksListRequest => {
    const query: AdminFeedbacksListRequest = {
      cityId: filters.cityId,
      phoneOrEmail: filters.phoneOrEmail,
      moderationStatus: filters.moderationStatus || DEFAULT_FILTERS_VALUES.moderationStatus,
      clientType: filters.clientType || DEFAULT_FILTERS_VALUES.clientType,
      careerId: filters.careerId || DEFAULT_FILTERS_VALUES.careerId,
    };

    if (withOnlyCount) {
      query.page = 1;
      query.pagination = 1;
    } else {
      query.page = filters.page || DEFAULT_FILTERS_VALUES.page;
      query.pagination = PER_PAGE;
    }

    return query;
  },
  toProcessingCountersQuery: (value?: ProcessingAndReviewsQueryParams): ProcessingCountersRequest => {
    return {
      cityId: value?.cityId,
      type: value?.clientType,
      careerId: value?.careerId,
      phoneOrEmail: value?.phoneOrEmail,
      vacancyId: {
        isEmpty: true,
      },
    };
  },
};
